import _ from 'underscore';

/*

filterService.js

Angular service to CRUD user filter settings

*/

angular.module('am4')
.factory('filterService', function($http, $q, UserService, appCacheService, apiUrl) {

    return {
        getFilters: function() {
            var filters = appCacheService.getAppCache('filters');
            // if filters need a "hard" update
            if (filters.refreshNeeded) {
                // fetch from API
                return UserService.user
                .then(function(user) {
                    return $http.get(apiUrl + '/users/' + encodeURIComponent(user.user_id) + '/filters');
                })
                .then(function(res) {
                    // save and return data
                    filters.data = res.data;
                    filters.refreshNeeded = false;
                    appCacheService.setAppCache('filters', filters);
                    return res.data;
                });
            }
            // otherwise instantly send cached filters
            return $q.when(filters.data);
        },
        createFilter: function(uuid, name, options, owner_id) {
            var filters = appCacheService.getAppCache('filters');
            // make sure next update is hard pull
            filters.refreshNeeded = true;
            appCacheService.setAppCache('filters', filters);

            return UserService.user
            .then(function(user) {
                // create request body
                var postRequestParams = {
                    owner_id: user.user_id,
                    name: name,
                    options: options
                };
                // if logged in user isn't owner of the filter, sett to null
                if (owner_id) {
                    postRequestParams.filter_uuid = (owner_id === user.user_id) ? uuid : null;
                }
                return $http.post(apiUrl + '/users/' + encodeURIComponent(user.user_id) + '/filters', postRequestParams);
            })
            .then(function(res) {
                return res.data;
            });
        },
        getFilterById: function(id) {
            var that = this,
                filters = appCacheService.getAppCache('filters');

            if (filters.data) {
                return $q(function(resolve, reject) {
                    var filter = _.findWhere(filters.data, {
                        filter_uuid: id
                    });

                    if (filter) {
                        resolve(filter);
                    } else {
                        reject('No filter found with UUID ' + id);
                    }
                });
            }
            return this.getFilters()
            .then(function() {
                return that.getFilterById(id);
            });
        },
        deleteFilterById: function(id) {
            var filters = appCacheService.getAppCache('filters');
            filters.refreshNeeded = true;
            appCacheService.setAppCache('filters', filters);

            return UserService.user
            .then(function(user) {
                return $http.delete(apiUrl + '/users/' + encodeURIComponent(user.user_id) + '/filters/' + id);
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/filter.js